<template>
  <div v-if="badges && badges.length > 0" class="badges-container">
    <span v-for="badgeId in badges" :key="badgeId" class="badge-wrapper" :title="getBadgeName(badgeId)">
      <span v-if="getBadgeImage(badgeId)" class="state-badge-circle">
        <img :src="getBadgeImage(badgeId)" :alt="getBadgeName(badgeId)" class="badge-img" />
      </span>
      <span v-else class="badge-icon">{{ getBadgeEmoji(badgeId) }}</span>
    </span>
  </div>
</template>

<script>
import { getBadgeById } from '../utils/badges';

export default {
  name: 'BadgeDisplay',
  props: {
    badges: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: 'Badges'
    }
  },
  setup() {
    const getBadgeById_fn = getBadgeById;

    const getBadgeName = (badgeId) => {
      if (badgeId.startsWith('first-in-')) {
        const state = badgeId.replace('first-in-', '');
        return `First in ${state}`;
      }
      const badge = getBadgeById_fn(badgeId);
      return badge ? badge.name : 'Achievement';
    };

    const getBadgeImage = (badgeId) => {
      if (badgeId.startsWith('first-in-')) {
        const state = badgeId.replace('first-in-', '').toLowerCase();
        return `https://raw.githubusercontent.com/djaiss/mapsicon/master/us/${state}/128.png`;
      }
      return null;
    };

    const getBadgeEmoji = (badgeId) => {
      const badge = getBadgeById_fn(badgeId);
      return badge ? badge.emoji : '🏆';
    };

    const getBadgeDescription = (badgeId) => {
      if (badgeId.startsWith('first-in-')) {
        const state = badgeId.replace('first-in-', '');
        return `First person to review a restaurant in ${state}`;
      }
      const badge = getBadgeById_fn(badgeId);
      return badge ? `${badge.name}: ${badge.description}` : 'Achievement';
    };

    return {
      getBadgeName,
      getBadgeEmoji,
      getBadgeImage,
      getBadgeDescription
    };
  }
};
</script>

<style scoped>
.badges-container {
  display: flex;
  gap: 0.25rem;
  align-items: center;
}

.badge-icon {
  font-size: 1.2rem;
  cursor: help;
  transition: transform 0.2s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.state-badge-circle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.8em;
  height: 1.8em;
  background-color: #e3f2fd;
  border: 1px solid #90caf9;
  border-radius: 50%;
  vertical-align: middle;
}

.badge-img {
  width: 1.2em;
  height: 1.2em;
  object-fit: contain;
}

.badge-icon:hover {
  transform: scale(1.2);
}

.badge-img:hover {
  transform: scale(1.2);
}
</style>
